<template>
  <q-dialog 
    :visible="isVisible" 
    title="权限编辑" 
    width="500px" 
    :innerScroll="false" 
    @close="onCancel"
    @cancel="onCancel"
    @confirm="confirm"
  >
    <div class="content">
      <el-tree
        ref="treeRef"
        :data="treeData"
        show-checkbox
        node-key="id"
        :default-expanded-keys="ids"
        :default-checked-keys="ids"
        :props="defaultProps"
        @check="checkChange"
      >
      </el-tree>
    </div>
  </q-dialog>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      treeData: [],
      defaultProps: {
        children: 'childrenList',
        label: 'name'
      },
      ids: []
    };
  },
  mounted() {
    this.getOrgTree();
  },
  methods: {
    getOrgTree() {
      this.$api.configure.orgTree()
        .then(res => {
          this.treeData = [res.data];
        });
    },
    open(ids,roleCode) {
      this.ids = ids
      this.roleCode = roleCode
      this.isVisible = true
    },
    checkChange(data,checkedNodes) {
      this.ids = checkedNodes.checkedKeys
    },
    confirm() {
      this.$api.configure.saveRoleOrgAuth({ids: this.ids, roleCode: this.roleCode})
        .then(res => {
          if (res.success) {
            this.$emit('saveSuccess')
            this.$message.success('保存成功')
            this.onCancel()
          }
        })
    },
    onCancel() {
      this.isVisible = false;
      this.ids = []
      this.$nextTick(() => {
        this.$refs.treeRef.setCheckedKeys(this.ids)
      })
    }
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-select {
  width: 100%;
}
.content {
  height: 60vh;
  overflow: auto;
}
</style>
